// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"bd3988e3","581":"84b6f939","676":"78471ed1","878":"ed55d602"}[chunkId] + ".chunk.js";
};